<template>
  <div
    class="m-merge-form-box"
  >
    <div class="merge-form-tips">
      {{ $t('message["1449"]') }}
    </div>
    <cube-form class="account-info-box">
      <cube-form-item
        v-for="(item, index) in mergeFormDatas.notsame"
        :key="item.key + index"
        class="account-item"
      >
        <span class="item-label">{{ item.title }}</span>
        <!-- <cube-validator ref="validator2" :model="checkList"  :rules="rules" v-model="valid">

          </cube-validator> -->
        <cube-radio-group
          v-model="item[item.key]"
          :options="item.values"
          position="right"
        />
      </cube-form-item>
    </cube-form>
    <div class="form-btn-box">
      <cube-button
        :light="true"
        type="reset"
        @click="reSetForm"
      >
        {{ $t('message["896"]') }}
      </cube-button>
      <cube-button
        type="submit"
        :primary="true"
        @click="subForm"
      >
        {{ $t('message["915"]') }}
      </cube-button>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { setAuth } from '@/lib/storage'
export default {
  data () {
    return {
    }
  },
  computed: {
    ...mapState('account/modify', ['mergeFormDatas'])
  },
  mounted () {
  },
  methods: {
    ...mapActions('merge', ['mergeForm']),
    async subForm () {
      let obj = { }
      this.mergeFormDatas.notsame.forEach(item => {
        obj = { ...obj, [item.key]: item[item.key] }
      })
      const chain = await this.mergeForm()
      chain.params({ notsame: obj, binduserid: this.mergeFormDatas.binduserid })
        .onSuccess(raw => {
          this.isLimitDialogShow = false
          setAuth(raw.Authorization)
          this.$store.commit('setAuth', raw.Authorization, { root: true })
          this.$router.push({ name: 'OrgIndex' })
        })
        .fetch()
    },
    reSetForm () {
      this.$emit('reSetForm')
    }
  }
}
</script>
<style lang="scss" scoped>
.m-merge-form-box::v-deep {
   height: 100%;
  width: 100%;
  // background:  #fff;
  .merge-form-tips {
    height: 48px;
    line-height: 48px;
    background: #e8f4ff;
    color: #4CA0F2;
    margin-bottom: 8px;
    padding: 0 16px;
    font-size: 13px;
  }
    .account-item {
      line-height: 56px;
      min-height: 56px;
      font-size: 16px;
      padding-right: 0;
    .cube-form-field {
      display: flex;
      flex-direction: row;
      .item-label {
        display: inline-block;
        width: 35%;
        color: #888;
        font-size: 16px;
        vertical-align: top;
      }
      .cube-validator {
        width: 65%;
        display: inline-block;
      }
      .cube-radio-group {
        display: inline-block;
        width: 100%;
        .cube-radio-ui {
          position: absolute;
          right: 16px;
        }
      }
      .a-item-cell {
        width: 75%;
        position: relative;
        color: #333;
        font-size: 16px;
        i{
          position:absolute;
          right: 0;
          color: #ccc;
        }
        span {
          color: #999;
        }
      }
    }
  }
}
</style>
